import React, { useContext, useState } from 'react'
import styled from '@emotion/styled'
import { Form } from 'react-final-form'
import { withTheme } from '@emotion/react'
import ReactResizeDetector from 'react-resize-detector'

// context
import { RfqContext } from '@duplo/components/lib/RfqProvider'

// utils
import { zipPrefillDecorator } from '@duplo/core/lib/form'
import { createHandleSubmitOrNext } from '@duplo/core/lib/flow'
import { isBrowser } from '@duplo/utils/lib/browser'


// common components
import BaseEsDataTracker from '@duplo/components/lib/BaseEsDataTracker'
import Navigation from '@duplo/components/lib/Navigation'
import { AdvertisingDisclosure } from '@duplo/components/lib/AdvertisingDisclosure'
import OfflineNotifier from '@duplo/components/lib/OfflineNotifier'
import ProgressBar from '@duplo/components/lib/ProgressBar'
import ProgressCalculator from '@duplo/components/lib/ProgressCalculator'
import QuestionSet from '@duplo/components/lib/QuestionSet'
import ScrollForMoreIndicator from '@duplo/components/lib/ScrollForMoreIndicator'
import SeoHelmet from '@duplo/components/lib/SeoHelmet'
import SpinnerOverlay from '@duplo/components/lib/SpinnerOverlay'
import Tcpa from '@duplo/components/lib/Tcpa'
let dataLotTest = isBrowser() ? window.location.search.includes('datalot') : false;

// styled components
const TemplateContainer = styled.div`
	background: ${({ theme }) => {
		if (dataLotTest) return 'salmon'
		return theme.questionSetBackgroundColor
	}};
	padding: 10px 10px 0;
	max-width: ${({ theme }) => theme.innerContentMaxWidth};
	margin: 0 auto;
`

const BodyWrapper = styled.div`
	${({ theme }) => theme.mq.L} {
		background: ${({ theme }) => theme.questionSetBackgroundColor};
	}
`

const QsForm = styled.form`
	background: ${({ theme }) => theme.questionSetBackgroundColor};
	margin-bottom: 0;
	user-select: none;
	width: 100%;
	${({ theme }) => theme.mq.L} {
		border: ${({ theme }) => theme.questionSetBorder};
	}
`

const NavWrapper = styled.div`
	padding: 0 10px 10px;
	position: fixed;
	background: ${({ theme }) => theme.questionSetBackgroundColor};
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	max-width: ${({ theme }) => theme.innerContentMaxWidth};
	margin: 0 auto;
`
const NavBox = styled.div`
	margin-top: ${({ theme }) => theme.spacers.S};
	background: ${({ theme }) => theme.questionSetBackgroundColor};
`
const ProgressBox = styled.div`
	height: 18px;
`
const TESTING = styled.div`
	text-align: center;
	font-size: x-large;
	font-weight: 800;
	color: #1a214e;
    background: #fff57b;
}
`
const CenteredText = styled.div`
	text-align: center;
`
function WidgetView({ theme: { themeName } }) {
	const rfqContext = useContext(RfqContext)
	const { initialFormValues, isLoadingGlobal } = rfqContext

	const [navWrapperHeight, setNavWrapperHeight] = useState(100)
	const handleNavResize = (width, height) => {
		setNavWrapperHeight(height)
	}
	const dataLotTest = isBrowser() ? location.search.includes('datalot') : false;
	return (
		<TemplateContainer>
			{dataLotTest && <TESTING>TESTING</TESTING>}
			<SeoHelmet />
			<OfflineNotifier />
			<BodyWrapper>
				<Form
					decorators={[zipPrefillDecorator]}
					initialValues={initialFormValues}
					onSubmit={createHandleSubmitOrNext(rfqContext, themeName)}
				>
					{({ handleSubmit, submitting, submitFailed, valid }) => (
						<QsForm onSubmit={handleSubmit}>
							<ScrollForMoreIndicator
								height={`calc(100vh - ${navWrapperHeight}px - 10px)`}
								key={rfqContext.currentPageNumber}
							>
								<QuestionSet handleSubmitOrNext={handleSubmit} />
							</ScrollForMoreIndicator>
							<NavWrapper>
								<ReactResizeDetector handleWidth handleHeight onResize={handleNavResize} />
								<NavBox>
									<Navigation isSubmitting={submitting} hasErrors={submitFailed && !valid} />
								</NavBox>
								<ProgressBox>
									<ProgressCalculator>
										{(progressCalcProps) => <ProgressBar {...progressCalcProps} />}
									</ProgressCalculator>
								</ProgressBox>
								<CenteredText>
									<AdvertisingDisclosure />
									<Tcpa shouldShowPrivacyLinks={true} shouldShowTrustLogos={false} />
								</CenteredText>
							</NavWrapper>
						</QsForm>
					)}
				</Form>
			</BodyWrapper>
			{isLoadingGlobal && <SpinnerOverlay />}
			<BaseEsDataTracker />
		</TemplateContainer>
	)
}

export default withTheme(WidgetView)
